<template>
  <div>
    <v-col cols="12" md="4">
      <v-btn class="btn-save" @click="showSellerZoneConfiguration = true">Configuración de zonas para vendedores</v-btn>
    </v-col>
    <v-dialog v-model="showSellerZoneConfiguration" max-width="60%" scrollable>
      <v-card>
        <v-card-title>
          <h3>Configuración de zonas para vendedores</h3>
        </v-card-title>
        <v-card-text>
          <v-row class="mt-2">
            <v-col cols="10">
              <v-text-field v-model="sellerZone" label="Agregar zonas para vendedores" dense outlined
                chips></v-text-field>
            </v-col>
            <v-col cols="2">
              <v-btn class="btn-save" @click="addSellerZone"><v-icon> mdi-content-save</v-icon></v-btn>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <ManageStoreSellerZoneTable :sellerZones="sellerZones" @onDelete="getSellerZones()"/>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
      <block v-if="loading" />
    </v-dialog>
  </div>
</template>
<script>
import ManageStoreSellerZoneTable from './ManageStoreSellerZoneTable.vue';

export default {
  name: "ManageStoreSellerZoneDialog",
  components: {
    ManageStoreSellerZoneTable
  },
  data() {
    return {
      loading: false,
      showSellerZoneConfiguration: false,
      sellerZone: '',
      sellerZones: []
    }
  },
  mounted() {
    this.getSellerZones()
  },
  methods: {
    getSellerZones() {
      this.loading = true
      this.$API.sellerZone.getSellerZones()
        .then(sellerZones => {
          if (sellerZones.length > 0) {
            this.sellerZones = sellerZones
          }
        })
        .finally(() => this.loading = false)
    },
    addSellerZone() {
      this.loading = true
      const newZone = {
        Name: this.sellerZone
      }
      this.$API.sellerZone.addSellerZone(newZone)
        .then(sellerZone => {
          this.sellerZones.push(sellerZone)
          this.sellerZone = ''
        })
        .finally(() => this.loading = false)
    },
  }
};
</script>
